import React from 'react';
import { Section } from '../ui/Section';
import { Card } from '../ui/Card';
import { Gift } from 'lucide-react';
export function Bonos() {
  return <Section background="off-white" data-id="element-1">
      <div className="text-center mb-12" data-id="element-2">
        <div className="inline-flex items-center gap-2 bg-stone-900 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6" data-id="element-3">
          <Gift className="w-4 h-4" data-id="element-4" />
          Bonos de lanzamiento — gratis hoy
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-5">
          Además, hoy te llevás 3 bonos (gratis)
        </h2>
        <p className="text-stone-600 max-w-2xl mx-auto" data-id="element-6">
          No porque "quede lindo" decir bonos. Sino porque este sistema tiene
          que sobrevivir a la vida real. Y lo que suele romper cualquier plan no
          es la falta de información… Es la <strong data-id="element-7">falta de cierre</strong>,
          los <strong data-id="element-8">cambios de semana</strong>, y los días de{' '}
          <strong data-id="element-9">cero energía.</strong>
        </p>
      </div>

      <div className="space-y-8" data-id="element-10">
        {/* Bono 1 */}
        <Card className="overflow-hidden border-2 border-transparent hover:border-amber-200 transition-all" data-id="element-11">
          <div className="bg-stone-900 text-white p-2 text-center text-sm font-bold tracking-wide" data-id="element-12">
            VALOR: ARS 47.000 — GRATIS
          </div>
          <div className="p-8 md:flex gap-8 items-center" data-id="element-13">
            <div className="w-full md:w-1/3 mb-6 md:mb-0 flex-shrink-0" data-id="element-14">
              <img src="https://cdn.magicpatterns.com/uploads/mRsmBYnUwgrzuNPdv8ZsLs/01-NBONO.png" alt="Bono 1 — Domingo Cerrado" className="w-full h-auto rounded-lg shadow-md object-cover" data-id="element-15" />
            </div>
            <div className="flex-1" data-id="element-16">
              <h3 className="text-2xl font-bold text-stone-900 mb-2" data-id="element-17">
                DOMINGO CERRADO
              </h3>
              <p className="text-emerald-700 font-medium mb-4" data-id="element-18">
                Checklist 30 Min + Mini-Prep Sin Estrés
              </p>
              <p className="text-stone-600 mb-4" data-id="element-19">
                Si tu domingo se te va "pensando" y terminás arrancando la
                semana igual que siempre… esto te salva.
              </p>
              <ul className="space-y-2 text-sm text-stone-700 mb-6" data-id="element-20">
                <li className="flex gap-2" data-id="element-21">
                  🔹 Cerrar tu semana en 30 minutos con un guión paso a paso
                </li>
                <li className="flex gap-2" data-id="element-22">
                  🔹 Elegir menú + copiar lista por pasillos sin quedarte en
                  blanco
                </li>
                <li className="flex gap-2" data-id="element-23">
                  🔹 Dejar 2 mini-preps que te compran tiempo mental
                </li>
              </ul>
            </div>
          </div>
        </Card>

        {/* Bono 2 */}
        <Card className="overflow-hidden border-2 border-transparent hover:border-amber-200 transition-all" data-id="element-24">
          <div className="bg-stone-900 text-white p-2 text-center text-sm font-bold tracking-wide" data-id="element-25">
            VALOR: ARS 47.000 — GRATIS
          </div>
          <div className="p-8 md:flex gap-8 items-center" data-id="element-26">
            <div className="w-full md:w-1/3 mb-6 md:mb-0 flex-shrink-0" data-id="element-27">
              <img src="https://cdn.magicpatterns.com/uploads/bJtc1k2VRoiqm8q7wL4N2x/02-NBONO.png" alt="Bono 2 — Swaps Inteligentes" className="w-full h-auto rounded-lg shadow-md object-cover" data-id="element-28" />
            </div>
            <div className="flex-1" data-id="element-29">
              <h3 className="text-2xl font-bold text-stone-900 mb-2" data-id="element-30">
                SWAPS INTELIGENTES
              </h3>
              <p className="text-emerald-700 font-medium mb-4" data-id="element-31">
                "Si no hay X, hacé Y" (Sin Drama)
              </p>
              <p className="text-stone-600 mb-4" data-id="element-32">
                Este es el bono que hace que el plan no se caiga por una pavada.
                Porque lo que te rompe la semana no es "no saber"… Es que falta
                un ingrediente.
              </p>
              <ul className="space-y-2 text-sm text-stone-700 mb-6" data-id="element-33">
                <li className="flex gap-2" data-id="element-34">
                  🔹 Una matriz simple para reemplazar carbo/proteína/fibra
                </li>
                <li className="flex gap-2" data-id="element-35">
                  🔹 Swaps por escenarios reales: sin súper, sin ganas, sin
                  stock
                </li>
                <li className="flex gap-2" data-id="element-36">
                  🔹 Una tarjeta "3C en 10 segundos" para armar combos sin
                  pensar
                </li>
              </ul>
            </div>
          </div>
        </Card>

        {/* Bono 3 */}
        <Card className="overflow-hidden border-2 border-transparent hover:border-amber-200 transition-all" data-id="element-37">
          <div className="bg-stone-900 text-white p-2 text-center text-sm font-bold tracking-wide" data-id="element-38">
            VALOR: ARS 47.000 — GRATIS
          </div>
          <div className="p-8 md:flex gap-8 items-center" data-id="element-39">
            <div className="w-full md:w-1/3 mb-6 md:mb-0 flex-shrink-0" data-id="element-40">
              <img src="https://cdn.magicpatterns.com/uploads/oGmqLQBkAjm6cxuNirAyJ2/03-NBONOS.png" alt="Bono 3 — Salvavidas 10 Min" className="w-full h-auto rounded-lg shadow-md object-cover" data-id="element-41" />
            </div>
            <div className="flex-1" data-id="element-42">
              <h3 className="text-2xl font-bold text-stone-900 mb-2" data-id="element-43">
                SALVAVIDAS 10 MIN
              </h3>
              <p className="text-emerald-700 font-medium mb-4" data-id="element-44">
                Menú de Emergencia (Sin Delivery, Sin Culpa)
              </p>
              <p className="text-stone-600 mb-4" data-id="element-45">
                Este es para esos días donde la cabeza no da, no cocinaste, y
                sentís que ya fue. Acá no hay motivación tóxica.
              </p>
              <ul className="space-y-2 text-sm text-stone-700 mb-6" data-id="element-46">
                <li className="flex gap-2" data-id="element-47">
                  🔹 10 opciones express para resolver en 10 minutos
                </li>
                <li className="flex gap-2" data-id="element-48">
                  🔹 Swaps por si te falta algo (sin empezar de cero)
                </li>
                <li className="flex gap-2" data-id="element-49">
                  🔹 Checklist de "despensa salvavidas" para que siempre tengas
                  plan
                </li>
              </ul>
            </div>
          </div>
        </Card>
      </div>
    </Section>;
}